export const allMustFields = [
    {
        id: 12,
        name: "Asfalt ve Yol Makinalari",
        subCategories: [
            {
                id: 54,
                name: "El Silindiri",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "enginePower",
                    "operatingWeight",
                    "compressionWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 55,
                name: "Toprak Silindiri",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "enginePower",
                    "operatingWeight",
                    "compressionWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                brandNames: ["brandName", "modelName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 56,
                name: "Asfalt Silindiri",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "operatingWeight",
                    "enginePower",
                    "operatingWeight",
                    "compressionWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 77,
                name: "Mini Tandem Silindiri",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "operatingWeight",
                    "enginePower",
                    "operatingWeight",
                    "compressionWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 57,
                name: "Finişer (Asfalt Serici)",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "compressionWidth"],
                required: ["modelName", "brandName", "modelYear", "noMustProp"],
                requestFields: ["brandName", "modelName", "compressionWidth", "noMustProp"],
            },

            {
                id: 75,
                name: "Lastik Tekerlekli Silindir",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "enginePower",
                    "operatingWeight",
                    "compressionWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 60,
                name: "Asfalt Püskürtme Aracı",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "spraySpeed"],
                required: ["modelName", "brandName", "modelYear", "spraySpeed"],
                requestFields: ["brandName", "modelName", "spraySpeed"],
            },
            {
                id: 61,
                name: "Su Tankeri",
                fields: ["brandName", "expertiseReport", "modelName", "operationMileage", "operationHour", "tankVolume"],
                required: ["modelName", "brandName", "modelYear", "tankVolume"],
                requestFields: ["brandName", "modelName", "tankVolume"],
            },
            {
                id: 62,
                name: "El Kompaktörü",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "operatingWeight"],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "loadCapacity"],
            },
            {
                id: 63,
                name: "Mobil Taş Kırma Makinası",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "maxFeedingSize", "loadCapacity"],
                required: ["modelName", "brandName", "modelYear", "loadCapacity"],
                requestFields: ["brandName", "modelName", "loadCapacity"],
            },
        ],
    },
    {
        id: 5,
        name: "Beton Grubu",
        subCategories: [
            {
                id: 20,
                name: "Beton Transmikseri",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "enginePower",
                    "nominalCapacity",
                    "waterTankCapacity",
                ],
                required: ["modelName", "brandName", "operationMileage", "nominalCapacity"],
                requestFields: ["brandName", "modelName", "operationMileage", "nominalCapacity"],
            },
            {
                id: 21,
                name: "Mobil Beton Pompası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "enginePower",
                    "maxHeight",
                    "maxDepth",
                    "maxWidth",
                    "concretePumpingCapacity",
                    "maxPressure",
                ],
                required: ["modelName", "brandName", "operationHour", "maxHeight"],
                requestFields: ["brandName", "modelName", "operationHour", "maxHeight"],
            },
            {
                id: 22,
                name: "Sabit Beton Pompası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "enginePower",
                    "maxHeight",
                    "concretePumpingCapacity",
                    "maxPressure",
                ],
                required: ["modelName", "brandName", "operationHour", "maxHeight"],
                requestFields: ["brandName", "modelName", "operationHour", "maxHeight"],
            },
        ],
    },
    {
        id: 2,
        name: "Dozer",
        subCategories: [
            {
                id: 16,
                name: "Dozer",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "operatingWeight"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight", "operationHour"],
            },
        ],
    },

    {
        id: 9,
        name: "Forklift ve İstifleyiciler",
        subCategories: [
            {
                id: 36,
                name: "Akülü Istifleyici",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "carryingCapacity",
                    "elevatorTypeId",
                    "liftingHeight",
                    "operatingArea",
                    "hasPlatform",
                ],
                required: ["modelName", "brandName", "operationHour", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "operationHour", "carryingCapacity"],
            },
            {
                id: 37,
                name: "Forklift",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "carryingCapacity",
                    "fuelTypeId",
                    "elevatorTypeId",
                    "liftingHeight",
                    "elevatorTypeId",
                ],
                required: ["modelName", "brandName", "carryingCapacity", "fuelType"],
                requestFields: ["brandName", "modelName", "carryingCapacity", "fuelType"],
            },
            {
                id: 38,
                name: "Reachtruck",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "carryingCapacity", "liftingHeight"],
                required: ["modelName", "brandName", "operationHour", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "operationHour", "carryingCapacity"],
            },
            {
                id: 39,
                name: "Sipariş Toparlayıcı",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "carryingCapacity"],
                required: ["modelName", "brandName", "operationHour", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "operationHour", "carryingCapacity"],
            },
            {
                id: 40,
                name: "Akülü Çekici",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "carryingCapacity"],
                required: ["modelName", "brandName", "operationHour", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "operationHour", "carryingCapacity"],
            },
            {
                id: 41,
                name: "Dar Koridor Istif Makinası",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "carryingCapacity", "liftingHeight"],
                required: ["modelName", "brandName", "operationHour", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "operationHour", "carryingCapacity"],
            },
            {
                id: 42,
                name: "Akülü Transpalet",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "carryingCapacity", "hasPlatform"],
                required: ["modelName", "brandName", "modelYear", "carryingCapacity"],
                requestFields: ["brandName", "modelName", "modelYear", "carryingCapacity"],
            },
        ],
    },
    {
        id: 3,
        name: "Greyder",
        subCategories: [
            {
                id: 17,
                name: "Greyder",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "operatingWeight", "bladeWidth"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
        ],
    },
    {
        id: 11,
        name: "Jeneratör / Aydınlatma",
        subCategories: [
            {
                id: 49,
                name: "Gazlı Jeneratör",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "frequency",
                    "maxPower",
                    "hasCabin",
                    "enginebrandName",
                ],
                required: ["modelName", "brandName", "modelYear", "maxPower"],
                requestFields: ["brandName", "modelName", "minPower", "maxPower"],
            },
            {
                id: 50,
                name: "Dizel Jeneratör",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "frequency",
                    "maxPower",
                    "hasCabin",
                    "enginebrandName",
                ],
                required: ["modelName", "brandName", "modelYear", "maxPower"],
                requestFields: ["brandName", "modelName", "minPower", "maxPower"],
            },
            {
                id: 51,
                name: "Benzinli Jeneratör",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "frequency",
                    "maxPower",
                    "hasCabin",
                    "enginebrandName",
                ],
                required: ["modelName", "brandName", "modelYear", "maxPower"],
                requestFields: ["brandName", "modelName", "minPower", "maxPower"],
            },
            {
                id: 52,
                name: "Jeneratör",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "frequency",
                    "maxPower",
                    "fuelTypeId",
                    "hasCabin",
                    "enginebrandName",
                ],
                required: ["modelName", "brandName", "modelYear", "maxPower"],
                requestFields: ["brandName", "modelName", "minPower", "maxPower"],
            },
            {
                id: 53,
                name: "Aydınlatma Kulesi",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "frequency",
                    "maxPower",
                    "fuelTypeId",
                    "hasTowerElevationSystem",
                    "lightningCapacity",
                ],
                required: ["modelName", "brandName", "modelYear", "maxPower"],
                requestFields: ["brandName", "modelName", "minPower", "maxPower"],
            },
        ],
    },
    {
        id: 4,
        name: "Kamyonlar",
        subCategories: [
            {
                id: 10,
                name: "Kamyonlar",
                fields: ["brandName", "expertiseReport", "modelName", "operationMileage", "enginePower", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operationMileage"],
            },
            {
                id: 18,
                name: "Kaya Kamyonu",
                fields: ["brandName", "expertiseReport", "modelName", "operationMileage", "enginePower", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operationMileage"],
            },
            {
                id: 19,
                name: "Belden Kırmalı Damperli Kamyon",
                fields: ["brandName", "expertiseReport", "modelName", "operationMileage", "enginePower", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operationMileage"],
            },
        ],
    },
    {
        id: 8,
        name: "Kompresörler",
        subCategories: [
            {
                id: 34,
                name: "Vidalı Kompresör",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "freeAirOutput"],
                required: ["modelName", "brandName", "modelYear", "enginePower"],
                requestFields: ["brandName", "modelName", "modelYear", "enginePower"],
            },
            {
                id: 35,
                name: "Pistonlu Kompresör",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "freeAirOutput"],
                required: ["modelName", "brandName", "modelYear", "enginePower"],
                requestFields: ["brandName", "modelName", "modelYear", "enginePower"],
            },
        ],
    },
    {
        id: 14,
        name: "Konteyner",
        subCategories: [
            {
                id: 66,
                name: "Ofis Konteyner",
                fields: ["brandName", "modelName", "modelYear", "width", "volume", "height", "floorCount"],
                required: ["brandName", "modelName", "volume", "modelYear"],
                requestFields: ["brandName", "modelName", "volume", "modelYear"],
            },
            {
                id: 67,
                name: "Şantiye Konteynerı",
                fields: ["brandName", "modelName", "modelYear", "width", "volume", "height", "floorCount"],
                required: ["brandName", "modelName", "volume", "modelYear"],
                requestFields: ["brandName", "modelName", "volume", "modelYear"],
            },
            {
                id: 68,
                name: "Yatakhane Konteynerı",
                fields: ["brandName", "modelName", "modelYear", "width", "volume", "height", "floorCount"],
                required: ["brandName", "modelName", "volume", "modelYear"],
                requestFields: ["brandName", "modelName", "volume", "modelYear"],
            },
            {
                id: 69,
                name: "Bekçi Konteynerı",
                fields: ["brandName", "modelName", "modelYear", "width", "volume", "height"],
                required: ["brandName", "modelName", "volume", "modelYear"],
                requestFields: ["brandName", "modelName", "volume", "modelYear"],
            },
            {
                id: 70,
                name: "Wc / Duş Konteyner",
                fields: ["brandName", "modelName", "modelYear", "width", "volume", "height"],
                required: ["brandName", "modelName", "volume", "modelYear"],
                requestFields: ["brandName", "modelName", "volume", "modelYear"],
            },
        ],
    },
    {
        id: 10,
        name: "Manlift (Personel Yükselticiler) / Platformlar",
        subCategories: [
            {
                id: 43,
                name: "Eklemli Platformlar",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "fuelTypeId",
                    "operatingHeight",
                    "maxLoadCapacity",
                    "workingRadius",
                ],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operatingHeight"],
            },
            {
                id: 74,
                name: "Kamyon Üstü Sepetli Platform",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "fuelTypeId",
                    "bomLength",
                    "operatingHeight",
                    "maxLoadCapacity",
                    "workingRadius",
                ],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operatingHeight"],
            },
            {
                id: 44,
                name: "Dikey Platform",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "operatingHeight", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operatingHeight"],
            },
            {
                id: 45,
                name: "Teleskobik Platform",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "fuelTypeId",
                    "operatingHeight",
                    "maxLoadCapacity",
                    "workingRadius",
                ],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "operatingHeight", "maxLoadCapacity"],
            },
            {
                id: 46,
                name: "Paletli Platform (Örümcek)",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "operatingHeight",
                    "maxLoadCapacity",
                    "workingRadius",
                ],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operatingHeight"],
            },
            {
                id: 47,
                name: "Iskele",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "operatingHeight", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operatingHeight", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity", "operatingHeight"],
            },
            {
                id: 48,
                name: "Makaslı Platform",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "fuelTypeId", "operatingHeight", "maxLoadCapacity"],
                required: ["modelName", "brandName", "operatingHeight", "fuelType"],
                requestFields: ["brandName", "modelName", "operatingHeight", "fuelType"],
            },
        ],
    },
    {
        id: 13,
        name: "Nakliye Makinalari",
        subCategories: [
            {
                id: 64,
                name: "Lowbed",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "maxLoadCapacity",
                    "platformLength",
                    "platformWidth",
                ],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity"],
            },
            {
                id: 65,
                name: "Çekici",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "maxLoadCapacity",
                    "platformLength",
                    "platformWidth",
                ],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity"],
            },
            {
                id: 71,
                name: "Traktör",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "maxLoadCapacity",
                ],
                required: ["modelName", "brandName", "operationMileage", "maxLoadCapacity"],
                requestFields: ["brandName", "modelName", "maxLoadCapacity"],
            },
        ],
    },
    {
        id: 15,
        name: "Pick-up SUV",
        subCategories: [
            {
                id: 72,
                name: "Pick-up SUV",
                fields: ["brandName", "modelName", "expertiseReport", "operationMileage", "enginePower", "fuelTypeId"],
                required: ["modelName", "brandName", "modelYear", "operationMileage"],
                requestFields: ["brandName", "modelName", "enginePower"],
            },
        ],
    },
    {
        id: 7,
        name: "Temizlik Makineleri",
        subCategories: [
            {
                id: 29,
                name: "Yol Temizleme Makinası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "fuelTypeId",
                    "workingSpeed",
                    "cleaningCapacity",
                    "garbageCollectionBin",
                    "usageFields",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operationHour"],
                requestFields: ["brandName", "modelName", "modelYear", "operationHour"],
            },
            {
                id: 30,
                name: "Iticili Yıkama Makinası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "fuelTypeId",
                    "workingSpeed",
                    "cleaningCapacity",
                    "garbageCollectionBin",
                    "usageFields",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operationHour"],
                requestFields: ["brandName", "modelName", "modelYear", "operationHour"],
            },
            {
                id: 31,
                name: "Binicili Yıkama Makinası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "fuelTypeId",
                    "workingSpeed",
                    "cleaningCapacity",
                    "garbageCollectionBin",
                    "usageFields",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operationHour"],
                requestFields: ["brandName", "modelName", "modelYear", "operationHour"],
            },
            {
                id: 32,
                name: "Iticili Süpürme Makinası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "fuelTypeId",
                    "workingSpeed",
                    "cleaningCapacity",
                    "garbageCollectionBin",
                    "usageFields",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operationHour"],
                requestFields: ["brandName", "modelName", "modelYear", "operationHour"],
            },
            {
                id: 33,
                name: "Süpürme & Yıkama Makinası",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationMileage",
                    "operationHour",
                    "enginePower",
                    "fuelTypeId",
                    "workingSpeed",
                    "cleaningCapacity",
                    "garbageCollectionBin",
                    "usageFields",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "modelYear", "operationHour"],
                requestFields: ["brandName", "modelName", "modelYear", "operationHour"],
            },
        ],
    },
    {
        id: 6,
        name: "Vinçler",
        subCategories: [
            {
                id: 23,
                name: "Mobil Vinç",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "modelYear",
                    "operationHour",
                    "enginePower",
                    "operatingWeight",
                    "bomLength",
                ],
                required: ["modelName", "brandName", "modelYear", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operatingWeight"],
            },
            {
                id: 24,
                name: "Paletli Vinç",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "operatingHeight", "operatingWeight"],
                required: ["modelName", "brandName", "operatingWeight", "operationHour"],
                requestFields: ["brandName", "modelName", "operatingWeight", "operationHour"],
            },
            {
                id: 25,
                name: "Kule Vinç",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "operatingWeight", "operatingHeight", "bomLength"],
                required: ["modelName", "brandName", "operatingWeight", "operationHour"],
                requestFields: ["brandName", "modelName", "operatingWeight", "operationHour"],
            },
            {
                id: 26,
                name: "Paletli Örümcek Vinç",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "operatingWeight",
                    "fuelTypeId",
                    "operatingHeight",
                    "operationWidth",
                ],
                required: ["modelName", "brandName", "operatingWeight", "operationHour"],
                requestFields: ["brandName", "modelName", "operatingWeight", "operationHour"],
            },
            {
                id: 27,
                name: "Kamyon Üstü Vinç (Hiyap)",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "operatingWeight", "breakingInfo", "bomLength"],
                required: ["modelName", "brandName", "operatingWeight", "operationHour"],
                requestFields: ["brandName", "modelName", "operatingWeight", "operationHour"],
            },
        ],
    },
    {
        id: 1,
        name: "Hafriyat Grubu",
        subCategories: [
            {
                id: 1,
                name: "Ekskavatörler (Kazıcı)",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "brandName",
                    "modelName",
                    "operationHour",
                    "drivingEquipment",
                    "enginePower",
                    "operatingWeight",
                    "bomLength",
                    "maxDepth",
                    "loadCapacity",
                ],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 2,
                name: "Mini Ekskavatörler (Mini Kazıcı)",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "drivingEquipment",
                    "enginePower",
                    "tankCapacity",
                    "operatingWeight",
                    "tankCapacity",
                    "bomLength",
                    "loadCapacity",
                ],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 3,
                name: "Loder (Yükleyici)",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "drivingEquipment",
                    "enginePower",
                    "operatingWeight",
                    "tankCapacity",
                    "loadCapacity",
                ],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 4,
                name: "Beko Loder (Kazıcı-Yükleyici)",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "drivingEquipment",
                    "enginePower",
                    "operatingWeight",
                    "bomLength",
                    "loadCapacity",
                ],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 5,
                name: "Mini Kazıcı-Yükleyici",
                fields: [
                    "brandName",
                    "expertiseReport",
                    "modelName",
                    "operationHour",
                    "drivingEquipment",
                    "enginePower",
                    "operatingWeight",
                    "loadCapacity",
                ],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 76,
                name: "Mini Belden Kırmalı Yükleyici",
                fields: ["brandName", "expertiseReport", "operationHour", "enginePower", "operatingWeight", "loadCapacity"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 6,
                name: "Çekili Skreyper",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "tankCapacity", "loadCapacity"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 7,
                name: "Motorlu Skreyper",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "enginePower", "tankCapacity", "loadCapacity"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
            {
                id: 8,
                name: "Mini Yükleyiciler",
                fields: ["brandName", "expertiseReport", "modelName", "operationHour", "drivingEquipment", "enginePower", "loadCapacity"],
                required: ["modelName", "brandName", "operationHour", "operatingWeight"],
                requestFields: ["brandName", "modelName", "operationHour", "operatingWeight"],
            },
        ],
    },
    {
        id: 16,
        name: "Diğer",
        subCategories: [
            {
                id: 73,
                name: "Drone",
                fields: ["brandName", "expertiseReport", "modelName", "cameraResolution", "flightTime", "flightDistance"],
                required: ["modelName", "brandName", "cameraResolution", "flightTime"],
                requestFields: ["brandName", "modelName", "flightTime", "cameraResolution"],
            },
            {
                id: 79,
                name: "Diğer",
                fields: ["brandName", "modelName", "modelYear", "noMustProp"],
                required: ["modelName", "brandName", "modelYear", "noMustProp"],
                requestFields: ["brandName", "modelName", "modelYear", "noMustProp"],
            },
        ],
    },
    {
        id: 17,
        name: "Telehandler",
        subCategories: [
            {
                id: 78,
                name: "Telehandler",
                fields: ["brandName", "expertiseReport", "modelName", "operatingWeight", "bomLength"],
                required: ["modelName", "brandName", "operatingWeight", "bomLength"],
                requestFields: ["brandName", "modelName", "operatingWeight", "bomLength"],
            },
        ],
    },
];

export const dummyAttachments = [
    { id: 146, name: "Asfalt Traşlama" },
    { id: 155, name: "Beton Kovası Mikseri" },
    { id: 164, name: "Elek Ataşmanı" },
    { id: 169, name: "Fiber Optik Kanal Açma" },
    { id: 172, name: "Forklift Ataşmanı" },
    { id: 174, name: "Greyder Ataşmanı" },
    { id: 176, name: "Hazneli Sulu Süpürge" },
    { id: 190, name: "Kırıcı Öğütücü Kova" },
    { id: 195, name: "Lastik Sökme Ve Takma" },
    { id: 198, name: "Ray Kanalı Açma" },
    { id: 0, name: "Diğer" },
];
